import { CreateDepartmentModalTranslations } from "./types";

export const deTranslations: CreateDepartmentModalTranslations = {
    title: "Abteilung erstellen",
    name: "Name",
    createButtonText: "Erstellen",
};
